module.exports = __webpack_public_path__ + "static/media/pumpwhiz-4.38cc340c.png";